import { DEFAULT_SEAL_MOTOR_OIL } from "@/libs/calculations/constants";
import type {
  SealMotorOilQueryVariables,
  Seal_Motor_Oil_Bool_Exp
} from "gql/api";
import { Order_By } from "gql/api";

export function deleteSealMotorOils(arr: string[]): Seal_Motor_Oil_Bool_Exp {
  if (!arr) return {};
  return { id: { _in: arr } };
}

export function restoreSealMotorOils(arr: string[]): Seal_Motor_Oil_Bool_Exp {
  if (!arr) return {};
  return { id: { _in: arr } };
}

export const defaultSealMotorOilVars: SealMotorOilQueryVariables = {
  order_by: [{ name: Order_By.Asc }]
};

export const adminSealMotorOilVars: SealMotorOilQueryVariables = {
  order_by: [{ name: Order_By.Asc }]
};

export const kocSealMotorOilVars: SealMotorOilQueryVariables = {
  where: {
    _or: [
      { include_koc_timestamp: { _is_null: false } },
      { only_koc_timestamp: { _is_null: false } }
    ]
  }
};
export const ecopetrolSealMotorOilVars: SealMotorOilQueryVariables = {
  order_by: [{ name: Order_By.Asc }],
  where: {
    _or: [
      { include_ecopetrol_timestamp: { _is_null: false } },
      { only_ecopetrol_timestamp: { _is_null: false } }
    ]
  }
};

// This retrieves our S6.5 default seal motor oil
export const scenarioDefaultSealMotorOilVars: SealMotorOilQueryVariables = {
  where: {
    _and: [
      { name: { _eq: DEFAULT_SEAL_MOTOR_OIL } },
      {
        _or: [
          { include_koc_timestamp: { _is_null: true } },
          { only_koc_timestamp: { _is_null: true } },
          { include_ecopetrol_timestamp: { _is_null: true } },
          { only_ecopetrol_timestamp: { _is_null: true } }
        ]
      }
    ]
  }
};
